var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrate',{attrs:{"never":_vm.ssrOnly,"on-interaction":_vm.onInteraction,"idle-timeout":_vm.idleTimeout,"trigger-hydration":_vm.triggerHydration,"when-idle":_vm.whenIdle,"when-visible":_vm.whenVisible}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }